import { AlertCircle, Check, CircleDashed, Clock, LucideIcon } from 'lucide-react';
import { JobCommitment } from '../helpers';

export const UNSCHEDULED_KEY = 'unscheduled';

export const commitmentMeta: Record<
  JobCommitment | 'notScheduled',
  { icon: LucideIcon; className: string }
> = {
  rejected: { icon: AlertCircle, className: 'text-danger-600' },
  draft: { icon: CircleDashed, className: 'text-neutral-500' },
  waiting: { icon: Clock, className: 'text-warning-700' },
  notScheduled: { icon: CircleDashed, className: 'text-warning-700' },
  confirmed: { icon: Check, className: 'text-primary-700' },
  done: { icon: Check, className: 'text-primary-700' },
};
